"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _debug = _interopRequireDefault(require("debug"));
var _constants = _interopRequireWildcard(require("../../constants"));
var _location = require("../../utils/location");
var _auth = require("../../utils/auth");
var _SessionStorage = _interopRequireDefault(require("../../../shared/SessionStorage"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const info = (0, _debug.default)('AppFrame:auth:pcas');
class PCASAuthStrategy {
  constructor(redirectToIndex, customLogout, config) {
    this.execAuthentication = ({
      initAppframe,
      createSession
    }) => {
      let returnURL = _SessionStorage.default.get(_constants.default.RETURN_URL);
      info(`execAuthentication - returnURL: ${returnURL}`);
      _SessionStorage.default.remove(_constants.default.RETURN_URL);
      if (returnURL && returnURL.indexOf('#') > 0) {
        info('execAuthentication - getting return url without hash');
        returnURL = returnURL.split('#')[0];
      }
      if (returnURL && window.location.href !== returnURL + window.location.hash) {
        window.location.replace(returnURL + window.location.hash);
      } else {
        const token = (0, _location.getHashValue)('id_token');
        const state = (0, _location.getHashValue)('state');
        let nonce;
        if (token) {
          nonce = (0, _auth.parseJWT)(token).nonce;
        }
        if (token && state === _SessionStorage.default.get(_constants.default.AUTH_STATE) && nonce === _SessionStorage.default.get(_constants.default.AUTH_NONCE)) {
          info('execAuthentication - creating session');
          createSession(token);
        } else {
          info('execAuthentication - initialize AppFrame');
          initAppframe();
        }
      }
    };
    this.redirectToLogin = (isLogout, federatedLogout) => {
      info(`redirectToLogin - isLogout: ${isLogout}`);
      const auth = this.config.auth || {};
      const redirectUri = `${window.location.origin}${this.config.appPrefix}/`;
      info(`redirectToLogin - redirectUri: ${redirectUri}`);
      const state = (0, _auth.generateHash)(auth.clientID, (0, _auth.randomString)(8));
      const nonce = (0, _auth.generateHash)(auth.clientID, (0, _auth.randomString)(32));
      _SessionStorage.default.set(_constants.default.AUTH_STATE, state);
      _SessionStorage.default.set(_constants.default.AUTH_NONCE, nonce);
      _SessionStorage.default.remove(_constants.default.MENU_KEY);
      if (!isLogout || !federatedLogout && !auth.redirectOnLogout) {
        _SessionStorage.default.set(_constants.default.RETURN_URL, window.location.href);
      }
      let url;
      if (federatedLogout) {
        url = federatedLogout;
      } else if (isLogout && auth.redirectOnLogout) {
        url = auth.redirectOnLogout.startsWith(window.location.protocol) ? auth.redirectOnLogout : window.location.origin + auth.redirectOnLogout;
      } else {
        url = auth.loginServer + '/auth' + '?client_id=' + auth.clientID + '&redirect_uri=' + redirectUri + '&response_type=id_token' + '&scope=openid+profile+email+groups+offline_access' + '&state=' + state + '&nonce=' + nonce;
      }
      window.location.replace(url);
    };
    this.completed = authorized => {
      info(`completed - authorized param: ${authorized}`);
      if (!authorized) return false;
      const pathname = (0, _location.removePrefix)(window.location.pathname, this.config.appPrefix);
      info(`completed - pathname: ${pathname}`);
      if ((0, _location.getHashValue)('id_token')) {
        info('completed - has id_token: true');
        window.history.pushState('', document.title, window.location.origin + window.location.pathname + window.location.search);
      }
      if (pathname === '/' || pathname === '') {
        info('completed - empty pathname');
        this.redirectToIndex();
        return true;
      }
      info('completed - return true');
      return true;
    };
    this.logout = logoutFn => {
      if (this.customLogout) {
        this.customLogout();
      } else {
        logoutFn('/session/current', 'delete', {
          baseURL: this.config.apiPrefixes.pcasSession
        });
      }
    };
    this.name = _constants.AUTH_STRATEGY.PCAS;
    this.config = config;
    this.redirectToIndex = redirectToIndex;
    this.customLogout = customLogout;
  }
}
var _default = exports.default = PCASAuthStrategy;